<template>
    <div class="container mx-auto h-screen">
        <!-- logo -->
        <div class="flex flex-col items-center justify-center mt-32">
            <img class="w-64" src="../assets/logo-megaluzz.png" alt="Megaluzz Logo">
        </div>

        <div class="flex flex-col items-center gap-y-4 mt-6 px-4">
            <h1 class="text-gray-600 font-bold text-xl sm:text-2xl text-center">Inscrição registrada com sucesso!</h1>
            <p class="text-gray-500 text-center max-w-xl">
                Após o evento, você receberá seu certificado por e-mail em até 3 dias úteis. Caso não receba, entre em contato com a Megaluzz.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EventRegisterSuccess'
}
</script>
